//Imports
import React from "react";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import ResponsiveAppBar from "../../../../components/appbar";
import Footer from "../../../../components/footer";
import "./omistyles.css"


//Function Starts
export default function Omipage(){

    //Functions & Declarations
   

//Rendered Parts starts

    return(
      <div>
          <ResponsiveAppBar/>
          <div className="omihandy">
            <h1>Omi Handy</h1>
            <br/>
            <p><strong> LIDL Connect:</strong> <br/>
            TEL.Nr. 01523 4721129 <br/>
            PW: 81Krenner479a<br/>
            <br/>
            verknüpfte E-Mail-Adresse: muscholl@t-online.de (auf Opis Laptop!)<br/>
            <br/>
            <strong>Handy:</strong><br/>
            PIN: 02000<br/>
            SIM-Karten-PIN: 02000<br/>
            PUK: 46168250<br/>
            SIM-Kartennr.: 19156018712986<br/>
            <br/>
            <strong>GMail Omi: e.muscholl@gmail.com</strong><br/>
            PW: 81Krenner479a</p> <br/>
            <br/>
            <strong>E-Mail Adresse</strong><br/>
            <p>Mailadresse: muscholl@t-online.de</p>
            <p>Passwort: KwuQ12At!</p>

          </div>


         
          <Footer/>
      </div>




    );


}